<template>
  <section class="hero">
    <!-- 粉色渐变背景 -->
    <div class="hero__bg" />

    <!-- Hero 上半部分切图 -->
    <!-- @asset: src/assets/memory-replace/Frame 2132.png -->
    <img :src="heroTopImg" class="hero__img hero__img--top" alt="" />

    <!-- Hero 下半部分切图 -->
    <!-- @asset: src/assets/memory-replace/Frame 2131.png -->
    <img :src="heroBottomImg" class="hero__img hero__img--bottom" alt="" />
  </section>
</template>

<script>
import heroTopImg from '@/assets/memory-replace/Frame 2132.png'    // @asset: Hero 上半部分切图
import heroBottomImg from '@/assets/memory-replace/Frame 2131.png' // @asset: Hero 下半部分切图

export default {
  name: 'MemoryHero',
  data() {
    return { heroTopImg, heroBottomImg }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/memory-algo.scss' as *;

.hero {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.hero__bg {
  position: absolute;
  inset: 0;
  background: $ma-grad-hero;
}

/* 切图通用样式 */
.hero__img {
  position: relative;
  z-index: 2;
  display: block;
  width: 80%;
  margin: 0 auto;
  height: auto;
}

/* 上半部分 */
.hero__img--top {
  margin-bottom: 50px;
  padding-top: 60px;
}
</style>
